import React, { useEffect, useRef } from 'react';
import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Card from './pages/Card';
import Shipping from './pages/Shipping';
import Details from './pages/Details';
import Login from './pages/Login';
import Register from './pages/Register';
import { get_category } from './store/reducers/homeReducer';
import { useDispatch, useSelector } from 'react-redux';
import { requestPushPermission, registerPushToken, listenForegroundMessages } from './utils/pushNotifications';
import CategoryShop from './pages/CategoryShop';
import SearchProducts from './pages/SearchProducts';
import Payment from './pages/Payment';
import Dashboard from './pages/Dashboard';
import ProtectUser from './utils/ProtectUser';
import Index from './components/dashboard/Index';
import Orders from './components/dashboard/Orders';
import ChangePassword from './components/dashboard/ChangePassword';
import Wishlist from './components/dashboard/Wishlist';
import OrderDetails from './components/dashboard/OrderDetails';
import Chat from './components/dashboard/Chat';
import ConfirmOrder from './pages/ConfirmOrder';
import SellerShop from './pages/SellerShop';
import BulkProducts from './pages/BulkProducts';
import WholesaleProducts from './pages/WholesaleProducts';
import VerifyOtp from './pages/VerifyOtp';
import Notification from './pages/Notification';
import CustomerAuth from './pages/CustomerAuth';
import MyProfile from './components/dashboard/MyProfile';
import MyCoupons from './components/dashboard/MyCoupons';
import MyReferral from './components/dashboard/MyReferral';
import RewardsCredits from './components/dashboard/RewardsCredits';
import CreditBalance from './components/dashboard/CreditBalance';
import MyList from './components/dashboard/MyList';
import FAQ from './pages/FAQ';
import AboutUs from './pages/AboutUs';
import BecomeSeller from './pages/BecomeSeller';
import Offers from './pages/Offers';
import CMSPage from './pages/CMSPage';
import Contact from './pages/Contact';
import { CurrencyProvider } from './context/CurrencyContext';
import PageSeo from './components/seo/PageSeo';
import { useRouteSeo } from './hooks/useSeo';

const SeoManager = () => {
  const location = useLocation();
  // Product and category pages inject their own <PageSeo> — skip here
  const skip =
    location.pathname.startsWith('/product/details/') ||
    location.pathname.startsWith('/products');
  const seo = useRouteSeo(skip ? null : location.pathname);

  if (!seo) return null;
  return <PageSeo {...seo} />;
};

function App() {
  const dispatch = useDispatch();
  const { userInfo } = useSelector(state => state.auth);
  const pushRegistered = useRef(false);

  useEffect(() => {
    dispatch(get_category());
  }, []);

  // Register push token once after login
  useEffect(() => {
    if (!userInfo?._id || pushRegistered.current) return;
    pushRegistered.current = true;

    requestPushPermission().then(token => {
      if (token) registerPushToken(token);
    });

    const unsubscribe = listenForegroundMessages((payload) => {
      const { title, body } = payload.notification || {};
      if (title && Notification.permission === 'granted') {
        new Notification(title, { body, icon: '/logo192.png' });
      }
    });
    return () => unsubscribe();
  }, [userInfo?._id]);


  return (
    <HelmetProvider>
    <CurrencyProvider>
    <BrowserRouter>
    <SeoManager />
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/customer-auth' element={<CustomerAuth/>} />
      <Route path='/login' element={<Login/>} />
      <Route path='/register' element={<Register/>} />
      <Route path='/verify-otp' element={<VerifyOtp/>} />
      <Route path='/shops' element={<Navigate to='/products' replace />} />
      <Route path="/shop/:sellerId" element={<SellerShop/>} />
      <Route path='/card' element={<Card/>} />
      <Route path='/shipping' element={<Shipping/>} />
      <Route path='/payment' element={<Payment/>} />
      <Route path='/bulk-products' element={<BulkProducts/>} />
      <Route path='/wholesale-products' element={<WholesaleProducts/>} />
      <Route path='/faq' element={<FAQ/>} />
      <Route path='/offers' element={<Offers/>} />
      <Route path='/become-seller' element={<BecomeSeller/>} />
      <Route path='/page/:slug' element={<CMSPage/>} />
      <Route path='/about' element={<AboutUs/>} />
      <Route path='/terms' element={<CMSPage slug="terms" />} />
      <Route path='/contact' element={<Contact/>} />
      <Route path='/blog' element={<CMSPage slug="blog" />} />
      <Route path='/products?' element={<CategoryShop/>} />
      <Route path='/products/search?' element={<SearchProducts/>} />
      <Route path='/product/details/:slug' element={<Details/>} /> 
      <Route path='/order/confirm?' element={<ConfirmOrder/>} /> 
      <Route path='/notifications' element={ <Notification/>} />

      <Route path='/dashboard' element={<ProtectUser/>} >
      <Route path='' element={<Dashboard/>} >        
      <Route path='' element={<Index/>} />
      <Route path='my-orders' element={<Orders/>} /> 
      <Route path='my-profile' element={<MyProfile/>} />
      <Route path='my-coupons' element={<MyCoupons/>} />
      <Route path='my-rewards' element={<RewardsCredits/>} />
      <Route path='my-referrals' element={<MyReferral/>} />
      <Route path='credit-balance' element={<CreditBalance/>} />
      <Route path='my-list' element={<MyList/>} />
      <Route path='change-password' element={<ChangePassword/>} /> 
      <Route path='my-wishlist' element={<Wishlist/>} /> 
      <Route path='order/details/:orderId' element={<OrderDetails/>} /> 
      <Route path='chat' element={<Chat/>} /> 
      <Route path='chat/:sellerId' element={<Chat/>} /> 
       
       </Route> 
      </Route>
      
       




    </Routes>
    
    </BrowserRouter>
    </CurrencyProvider>
    </HelmetProvider>
  );
}

export default App;
